export const MenuListArray2 = [
    {
        title: 'Home',
    },
    {
        title: 'Values',
        alias: 'values',
        to: '/#values'
    },
    {
        title: 'Pillars',
        alias: 'pillars',
        classChange: 'sub-menu-down',
        content: [
            {
                title: 'Neuroscience in Sports',
                to: '/pillars/3',
            },
            {
                title: 'Strength Development',
                to: '/pillars/0',
            },
            {
                title: 'Speed Development', 
                to: '/pillars/1',
            },
            {
                title: 'Football Skills', 
                to: '/pillars/2',
            },

        ],
    },
    {
        title: 'Team',
        alias: 'team',
        to: '/#team',
    },

    {
        title: 'Services',
        alias: 'services',
        classChange: 'sub-menu-down',
        content: [
            {
                title: 'PERFORMANCE HUB SESSIONS',
                to: '/services-details/0',
            },
            {
                title: "SCHOOL'S SPORTS PROGRAMS",
                to: '/services-details/1',
            },
            // {
            //     title: 'Skills and Shooting Sessions',
            //     to: '/services-details/2',
            // },
       

        ],
    },
    {
        title: 'Contact Us',
        alias: 'contact-us',
        to: '/contact-us',
    },
]